import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "302",
  height: "240",
  fill: "none",
  viewBox: "0 0 302 240"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#FFEFEF",
      "fill-opacity": ".5",
      d: "M3.006 155.647c10.038-23.256 32.841-51.316 66.496-32.925a167.5 167.5 0 0 1-22.996-27.141c-26.122-39.465-13.094-72.641 4-107.515 4.23-8.64 6.806-13.21 9.646-18.227 9.25-16.341 19.358-19.159 37.895-.65a264 264 0 0 1 37.465 47.312c16.206 26.58 21.486 54.295 9.393 86.74l-47.892 92.916c-32.256 33.499-52.71 18.061-82.136-3.352-12.32-10.148-19.041-20.544-11.87-37.158"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFEFEF",
      "fill-opacity": ".5",
      d: "M181.033 219.588c13.066-22.175 22.911-54.864-10.457-60.411a192 192 0 0 0 34.473-6.615c46.072-13.677 65.427-44.594 83.892-78.977 4.576-8.518 6.809-13.211 9.254-18.368 7.964-16.8 4.623-24.42-20.465-21.495a310 310 0 0 0-58.639 12.985c-30.261 9.981-55.382 26.84-74.669 56.713L96.53 196.337c-8.967 41.818 14.724 42.147 48.17 43.191 14.95-.408 26.998-4.1 36.333-19.94"
    }, null, -1)
  ])))
}
export default { render: render }